export default "__VITE_ASSET__DteC84Rg__"